<script>
  import { M, External } from '../../external';
  import Reactions from './Reactions/Index.svelte';
  import UsefulReaction from './Reactions/UsefulReaction.svelte';
  import getDateString from '../util/getDateString.js';

  export let comment,
    service,
    hasRepliesFetched,
    onShowReplies,
    onClickReply,
    allowReplies = false,
    isChildrenCollapsed,
    toggleChildren;

  const commentReactions = comment.reactions || {};
</script>

<div class="comment-footer col20 f-left flex align-center" style="position:relative;">
  {#if comment.context.resourceType === 'product_review_widget'}
    <UsefulReaction
      reactions={commentReactions}
      onGiveReaction={() => {
        service.giveReaction(comment.id, 'useful');
      }}
      onRemoveReaction={() => {
        service.removeReaction(comment.id, 'useful');
      }} />
  {:else}
    <Reactions
      isMember={true}
      reactions={commentReactions}
      smallIcon={true}
      onGiveReaction={(reaction) => {
        service.giveReaction(comment.id, reaction);
      }}
      onRemoveReaction={() => {
        service.removeReaction(comment.id);
      }} />
  {/if}
  {#if allowReplies}
    <div on:click={onClickReply} class="circle-post-share flex align-center circle-effect">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" />
      </svg>
      <span>{M.REPLY}</span>
    </div>
  {/if}
  {#if comment.updatedAt}
    <span title={getDateString(comment.updatedAt)} class="comment-edited-label flex align-center">{M.EDITED}</span>
  {/if}
  {#if comment.replies > 0}
    {#if !hasRepliesFetched}
      <span on:click={onShowReplies} class="comment-replies-count flex align-center"
        >{External.format(M.SHOW_X_REPLIES, 'x', comment.replies)}</span>
    {:else if isChildrenCollapsed}
      <span on:click={toggleChildren} class="comment-replies-count flex align-center"
        >{External.format(M.SHOW_X_REPLIES, 'x', comment.replies)}</span>
    {/if}
  {/if}
</div>
